import { PeriodOption } from '@/config/model';
import { duckDB } from '@analytical-alley/duckdb-react';
import {
    ModelOrActual,
    ModelVsActualTable,
    TModelVsActualTableRow,
} from './index';

async function getRows({
    period,
    type,
    startDate,
    endDate,
}: {
    type: ModelOrActual;
    period: PeriodOption;
    startDate?: string;
    endDate?: string;
}) {
    const query = ModelVsActualTable.rawQuery<() => TModelVsActualTableRow[]>(
        ({ table }) => {
            return `SELECT * FROM "${table} Filtered"('${type}', '${period}', ${startDate ? `'${startDate}'` : 'NULL'}, ${endDate ? `'${endDate}'` : 'NULL'});`;
        },
    );
    return await duckDB.query(query);
}

async function getAccuracy() {
    const query = ModelVsActualTable.rawQuery(
        ({ table }) => {
            const cte = (type: ModelOrActual, period: PeriodOption) =>
                `SELECT "Period name" AS period, "kpi" AS kpi FROM "${table} Filtered"('${type}', '${period}', NULL, NULL)`;

            return `
                WITH
                    monthly_actual AS (${cte('actual', 'monthly')}),
                    monthly_model  AS (${cte('model',  'monthly')}),
                    weekly_actual  AS (${cte('actual', 'weekly')}),
                    weekly_model   AS (${cte('model',  'weekly')})
                SELECT
                    (
                        SELECT AVG(100 * (1 - ABS(ma.kpi - mm.kpi) / NULLIF(ma.kpi, 0)))
                        FROM monthly_actual ma
                        JOIN monthly_model  mm ON ma.period = mm.period
                    ) AS monthlyAccuracy,
                    (
                        SELECT AVG(100 * (1 - ABS(wa.kpi - wm.kpi) / NULLIF(wa.kpi, 0)))
                        FROM weekly_actual wa
                        JOIN weekly_model  wm ON wa.period = wm.period
                    ) AS weeklyAccuracy
            `;
        },
        (
            data: {
                monthlyAccuracy: number | null;
                weeklyAccuracy: number | null;
            }[],
        ) => {
            return data[0]!;
        },
    );
    return await duckDB.query(query);
}

async function getStartAndEndDates() {
    const query = ModelVsActualTable.rawQuery(
        ({ table }) => {
            return `SELECT MIN("Period name") as startDate, MAX("Period name") as endDate FROM "${table}"`;
        },
        (data: { startDate: string; endDate: string }[]) => {
            return data[0]!;
        },
    );
    return await duckDB.query(query);
}

export const modelVsActualQueries = {
    getRows,
    getAccuracy,
    getStartAndEndDates,
};
